import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import Main from './main';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  // Pre-rendered HTML is present — hydrate cleanly for fast initial paint.
  ReactDOM.hydrateRoot(rootElement, <Main />, {
    onRecoverableError: (error, errorInfo) => {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[Hydration warning]:', error, errorInfo);
      }
    },
  });
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<Main />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
